import { StyleSheet } from 'react-native';
import theme from '@/config/theme';

export const styles = StyleSheet.create({
  darkGrey: {
    color: theme.colors.darkGrey,
  },
  inActiveStyle: {
    opacity: 0.5,
  },
  centerAlignment: {
    justifyContent: 'center',
    alignItems: 'center',
  },
  marginLeft: { marginLeft: 4 },
  container: {
    flex: 1,
    backgroundColor: theme.colors.lightBlue,
  },
  startButtonFull: {
    width: '100%',
  },
  startText: {
    textAlign: 'center',
    color: theme.colors.black,
  },
});
